export const TokenomicsChartImg = () => {
  return (
    <svg
      width='447'
      height='447'
      viewBox='0 0 447 447'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M223.5 0C270.709 5.6296e-07 316.705 14.9486 354.894 42.7024C393.083 70.4562 421.503 109.59 436.08 154.492L380.977 172.379C370.179 139.116 349.126 110.126 320.836 89.5666C292.546 69.0068 258.472 57.933 223.5 57.933L223.5 0Z'
        fill='#0024E6'
      />
      <path
        d='M436.089 154.521C450.659 199.425 450.636 247.79 436.024 292.68C421.411 337.571 392.959 376.681 354.748 404.404L320.727 357.512C349.034 336.975 370.111 308.003 380.936 274.748C391.761 241.494 391.778 205.666 380.984 172.401L436.089 154.521Z'
        fill='#3050FF'
      />
      <path
        d='M354.744 404.407C326.195 425.119 293.149 438.78 258.309 444.273C223.469 449.766 187.823 446.935 154.286 436.013L168.683 391.81C195.244 400.461 223.475 402.703 251.069 398.352C278.662 394.002 304.834 383.182 327.445 366.778L354.744 404.407Z'
        fill='#5570FF'
      />
      <path
        d='M154.291 436.014C109.412 421.399 70.3126 392.951 42.5958 354.748L69.8481 334.976C93.3894 367.424 126.599 391.586 164.717 404L154.291 436.014Z'
        fill='#657DFF'
      />
      <path
        d='M42.6319 354.797C14.9047 316.602 -0.0189362 270.609 1.80219e-05 223.41L33.6691 223.424C33.653 263.512 46.3284 302.576 69.8787 335.018L42.6319 354.797Z'
        fill='#8B9DFF'
      />
      <path
        d='M1.42615e-05 223.42C0.0168754 176.222 14.9754 130.24 42.7316 92.0655L69.9633 111.865C46.3884 144.289 33.6834 183.344 33.669 223.432L1.42615e-05 223.42Z'
        fill='#A5B3FF'
      />
      <path
        d='M42.7262 92.0729C70.4808 53.8973 109.608 25.4882 154.501 10.9172L164.896 42.9416C126.766 55.3176 93.5323 79.447 69.9588 111.872L42.7262 92.0729Z'
        fill='#C8D1FF'
      />
      <path
        d='M154.403 10.949C176.72 3.6942 200.041 -0.000738689 223.507 1.10766e-07L223.507 10.9699C201.192 10.9692 179.016 14.4828 157.795 21.3815L154.403 10.949Z'
        fill='#E2E6FF'
      />
      <g filter='url(#filter0_di_910_3364)'>
        <circle cx='223.5' cy='226.137' r='118.013' fill='#F4F7FD' />
      </g>
      <path
        d='M287.098 301.956H222.841C180.528 301.956 146.363 267.659 146.363 225.478C146.363 204.322 154.904 185.268 168.833 171.339C182.631 157.541 201.684 149 222.841 149C243.997 149 263.182 157.541 276.848 171.339C283.813 178.303 289.332 186.582 293.274 195.78C297.216 204.847 299.319 214.965 299.319 225.609C299.319 242.429 293.931 257.935 284.601 270.55C282.63 273.441 280.265 276.069 277.768 278.566L255.692 256.227C263.314 248.211 267.913 237.436 267.913 225.478C267.913 212.994 262.919 201.825 254.772 193.678C246.625 185.531 235.193 180.537 222.841 180.537C210.489 180.537 199.188 185.531 191.041 193.678C182.893 201.825 177.9 212.994 177.9 225.478C177.9 250.313 198.005 270.418 222.841 270.418V237.83L287.098 301.956Z'
        fill='url(#paint0_linear_910_3364)'
      />
      <defs>
        <filter
          id='filter0_di_910_3364'
          x='82.4868'
          y='85.1239'
          width='282.026'
          height='282.026'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='11.5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.508333 0 0 0 0 0.499014 0 0 0 0 0.499014 0 0 0 1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_910_3364'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_910_3364'
            result='shape'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-5' dy='9' />
          <feGaussianBlur stdDeviation='3' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0'
          />
          <feBlend
            mode='normal'
            in2='shape'
            result='effect2_innerShadow_910_3364'
          />
        </filter>
        <linearGradient
          id='paint0_linear_910_3364'
          x1='184.258'
          y1='303.263'
          x2='290.259'
          y2='137.636'
          gradientUnits='userSpaceOnUse'>
          <stop stop-color='#74EAE8' />
          <stop offset='1' stop-color='#0394E8' />
        </linearGradient>
      </defs>
    </svg>
  );
};
